import React from "react";
import { Helmet } from "react-helmet-async";
import ResponsiveImage from "../components/ResponsiveImage";

export default function About() {
 return <>
  <Helmet><title>About | Resham Gurung Photo Retouching</title><meta name="description" content="Learn about Resham Gurung's thoughtful approach to professional photo retouching and editing."/></Helmet>
  <main className="rg-page rg-editorial-about">
   <section className="rg-editorial-about-heading rg-container">
    <p className="rg-editorial-overline">MEET THE RETOUCHER</p>
    <h1>Hi, I’m Resham Gurung.</h1>
    <p>Photographer by hobby. Retoucher by profession.</p>
   </section>
   <section className="rg-editorial-about-content rg-container">
    <div className="rg-editorial-about-image"><ResponsiveImage src="/assets/img/bg/ray-intro.jpg" alt="Resham Gurung in a suit" sizes="(max-width: 560px) calc(100vw - 48px), (max-width: 900px) 420px, 520px" fetchpriority="high" /></div>
    <div className="rg-editorial-about-copy">
      <p className="rg-editorial-overline">A LITTLE ABOUT ME</p>
      <h2>Photography is my passion.<br />Retouching is my craft.</h2>
      <p className="rg-about-lead">I'm Resham Gurung, a professional photo retoucher based in Nepal, with 10+ years of experience refining images and bringing creative visions to life.</p>
      <section className="rg-about-story-block" aria-labelledby="about-perspective">
        <h3 id="about-perspective">A photographer’s perspective</h3>
        <p>I'm a photographer by hobby and a retoucher by profession. My love for photography gives me an understanding of what happens behind the lens — the light, the composition, and the feeling a photograph is meant to capture. That perspective guides every edit I make.</p>
      </section>
      <section className="rg-about-story-block" aria-labelledby="about-approach">
        <h3 id="about-approach">A retoucher’s approach</h3>
        <p>I believe great retouching should enhance what is already beautiful, not overpower it. Whether I'm working on real estate, portraits, weddings, or commercial images, my goal is always the same: polished, natural results that stay true to the original photograph.</p>
      </section>
      <p className="rg-about-personal-note">For me, every image deserves patience, attention, and a personal touch.</p>
    </div>
   </section>
   <section className="rg-editorial-feature rg-container" aria-labelledby="rg-feature-title">
    <p className="rg-editorial-overline">THE ART OF TRANSFORMATION</p>
    <h2 id="rg-feature-title">A little refinement. A lasting impression.</h2>
    <p>Discover the difference thoughtful editing can make.</p>
   </section>
  </main>
 </>;
}
